module.exports = __webpack_public_path__ + "img/other-icon.ef90f3ad.svg";